var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvitationPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 57,
    viewBox: "0 0 49 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 43.6986L41.5555 29.7757V1.38208H7.44482V29.7757L24.5002 43.6986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9472 9.33398H13.0532V12.1719H35.9472V9.33398Z",
    fill: "#6130a1BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9472 14.939H13.0532V17.7769H35.9472V14.939Z",
    fill: "#6130a1BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9472 20.6858H13.0532V23.5237H35.9472V20.6858Z",
    fill: "#6130a1BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9472 26.3872H13.0532V29.2251H35.9472V26.3872Z",
    fill: "#6130a1BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9397 18.7616V0H6.06033V18.7616L0 24.2275V57H49V24.2275L42.9397 18.7616ZM2.84256 27.8515L16.2367 38.7833L2.84256 52.1556V27.8515ZM18.4482 40.5882L24.5028 45.529L30.5575 40.5882L44.1506 54.1621H4.85224L18.4482 40.591V40.5882ZM32.7662 38.7833L46.1603 27.8515V52.1556L32.7662 38.7833ZM45.4013 24.8036L42.9425 26.81V22.5843L45.4013 24.8036ZM40.171 2.76415V29.0718L24.5 41.8624L8.82898 29.0718V2.76415H40.171ZM6.06033 26.8128L3.60152 24.8064L6.06033 22.5872V26.8128Z",
    fill: "#6130a1BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationPurple);
export default __webpack_public_path__ + "static/media/invitation-purple.78054db4813f051a9a972865f874d3fe.svg";
export { ForwardRef as ReactComponent };